import { FieldSection } from './types';
import { FieldObjectType } from '../field/types';
import { HttpClient } from '../http-client';

export class FieldSectionAPIClient extends HttpClient {
  public async getFieldSections(
    fieldSectionType: FieldObjectType,
  ): Promise<FieldSection[]> {
    return this.get<FieldSection[]>(
      `/field-sections?fieldSectionType=${fieldSectionType}`,
    );
  }
}
